import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectCurrentUser = (state) => {
    return selectOwnState(state).currentUser
}

export const selectUserList = (state) => {
    return selectOwnState(state).userList
}

export const selectCurrentUserId = (state) => {
    return selectOwnState(state).currentUserId
}

export const selectPasswordStatus = state => {
    return selectOwnState(state).passwordStatus
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}

export const selectValidationMessageList = state => {
    return selectOwnState(state).validationMessageList
}

export const selectError = state => {
    return selectOwnState(state).error
}

export const selectIsUniqueConstraintViolation = state => {
    const error = selectError(state)
    return error ? error.uniqueConstraintViolation : false
}

export const selectRoleList = (state) => {
    return selectOwnState(state).roleList
}

export const selectCurrentRole = (state) => {
    return selectOwnState(state).currentRole
}

export const selectCurrentRoleId = (state) => {
    return selectOwnState(state).currentRoleId
}


// WEBPACK FOOTER //
// ./src/modules/security/state/manage/selector.js